import axios from '../../plugins/axios'

export const listTechnicians = ({ state, commit }, { params, forceReload = false } = {}) => {
  // Si ya hay técnicos en memoria y no se solicita recarga forzada, reutilizar caché
  const hasParams = params && Object.keys(params).length > 0
  if (!forceReload && !hasParams && Array.isArray(state.technicians) && state.technicians.length > 0) {
    return Promise.resolve(state.technicians)
  }

  console.log('listTechnicians')
  const apiAddress = 'api/orden/tecnicos'
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
    params,
  }
  return axios.get(apiAddress, config).then((response) => {
    const technicians = response.data.map(t => ({
      ...t,
      tecnico: {
        ...t.tecnico,
        first_name: t.tecnico.first_name.charAt(0).toUpperCase() + t.tecnico.first_name.slice(1),
        last_name: t.tecnico.last_name.charAt(0).toUpperCase() + t.tecnico.last_name.slice(1),
      },
    }))

    commit('SET_TECHNICIANS', { technicians })
    return technicians
  })
}
